"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPageView } from "@/lib/analytics/track";

// App Router doesn't full-reload on client-side navigation, so a pathname
// change is the only reliable page-view trigger — fires on mount too.
// trackPageView() also closes out engagement tracking (time/scroll/click)
// for the page being left before recording the new one.
export default function AnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    trackPageView();
  }, [pathname]);

  return null;
}
